export function readStorage(key) {
    if (!key)
        return {};

    try {
        const jsonString = localStorage.getItem(key);
        return jsonString ? JSON.parse(jsonString) : null;
    }
    catch {
        localStorage.removeItem(key);
        return {};
    }
}
